module.exports = __webpack_public_path__ + "img/icon-settings-light-blue.7639dc6c.svg";